import {
  DEFAULT_ERR,
  GET_TIERING_REQUEST,
  GET_TIERING_SUCCESS,
  GET_TIERING_FAILED,
} from '../types';
import API from '../../apiConfig';

import { setAlert } from './alert';

// GET TIERING data
export const getTieirng = (supplierId) => async (dispatch) => {
  dispatch({
    type: GET_TIERING_REQUEST,
  });
  try {
    API.get(`supplier/tier?supplierId=${supplierId}`)
      .then((res) => {
        dispatch({
          type: GET_TIERING_SUCCESS,
          response: res.data,
        });
        // dispatch(setAlert('Succesfully Fetched Tiering Response', 'success'));
      })
      .catch((err) => {
        dispatch({
          type: GET_TIERING_FAILED,
          message: err.message,
        });
        dispatch(setAlert(err.message, 'error'));
      });
  } catch (err) {
    dispatch({
      type: GET_TIERING_FAILED,
      message: DEFAULT_ERR,
    });
    dispatch(setAlert(DEFAULT_ERR, 'error'));
  }
};
